var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPipelineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 390,
    viewBox: "0 0 512 390",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 64.5L512 64.5M167.5 0L167.5 390M343.5 0L343.5 390",
    stroke: "#082037",
    strokeWidth: 15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216 24H232V40H216V24Z",
    fill: "#082037"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M248 24H264V40H248V24Z",
    fill: "#082037"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M280 24H296V40H280V24Z",
    fill: "#082037"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31 201V102H129V162L92.5 201H31Z",
    fill: "#4789C2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5 206.5V158.5H134.5L86.5 206.5Z",
    fill: "#1165AD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31 192H80V201H31V192Z",
    fill: "#1165AD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120 151V102H129V151H120Z",
    fill: "#1165AD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 135H31L31 102H129V151H80V201H31L31 151H16L16 216H90.967L91 216.033L144.033 163L144 162.967V87H16V135ZM95 166H119.82L95 190.82V166Z",
    fill: "#082037"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M207 201V102H305V162L268.5 201H207Z",
    fill: "#69D781"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M262.5 206.5V158.5H310.5L262.5 206.5Z",
    fill: "#6BAB79"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M207 192H256V201H207V192Z",
    fill: "#6BAB79"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M296 151V102H305V151H296Z",
    fill: "#6BAB79"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192 135H207L207 102H305V151H256V201H207L207 151H192L192 216H266.967L267 216.033L320.033 163L320 162.967V87H192V135ZM271 166H295.82L271 190.82V166Z",
    fill: "#082037"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M207 347V248H305V308L268.5 347H207Z",
    fill: "#4789C2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M262.5 352.5V304.5H310.5L262.5 352.5Z",
    fill: "#1165AD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M207 338H256V347H207V338Z",
    fill: "#1165AD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M296 297V248H305V297H296Z",
    fill: "#1165AD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192 281H207L207 248H305V297H256V347H207L207 297H192L192 362H266.967L267 362.033L320.033 309L320 308.967V233H192V281ZM271 312H295.82L271 336.82V312Z",
    fill: "#082037"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M385 347V248H483V308L446.5 347H385Z",
    fill: "#81C4B3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M440.5 352.5V304.5H488.5L440.5 352.5Z",
    fill: "#4B9E8A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M385 338H434V347H385V338Z",
    fill: "#4B9E8A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M474 297V248H483V297H474Z",
    fill: "#4B9E8A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370 281H385L385 248H483V297H434V347H385L385 297H370L370 362H444.967L445 362.033L498.033 309L498 308.967V233H370V281ZM449 312H473.82L449 336.82V312Z",
    fill: "#082037"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelineIcon);
export default __webpack_public_path__ + "static/media/pipelineIcon.36b4e299a345667e4737c99ccbca45f6.svg";
export { ForwardRef as ReactComponent };